<template>
  <div class="auth-body">
    <Navbar class="navbar" />
    <div :class="isHome ? 'video-container' : ''">
     <video v-if="isHome" autoplay muted loop id="background-video">
        <source
          src="@/assets/background-video.mp4"
          ref="videoRef"
          type="video/mp4"
          playsinline
        />
        Your browser does not support HTML5 video.
      </video>

      <div :class="isHome ? 'auth-container-home' : 'auth-container'">
        <router-view :key="$route.fullPath" />
      </div>
          </div>
    <Footer :class="isHome ? 'footer-home': 'footer'" />
  </div>
</template>

<script>
import Footer from '../components/Footer.vue';
import Navbar from '../components/Navbar.vue';

export default {
  name: 'Auth',
  data() {
    return {
      isHome: true,
      paths: [
        '/terms-and-conditions',
        '/cc-connect-policy',
        '/privacy-policy',
        '/cc-events',
        '/cc-past-events',
        '/settings/company-first-settings',
        '/settings/user-first-settings',
        '/events-media-archive',
        '/events-media-archive/video',
        '/events-media-archive/gallery',
        '/events-media-archive/post-guide',
      ],
    };
  },
  components: {
    Navbar,
    Footer,
  },
  watch: {
    '$route.path': {
      handler(path) {
        if (this.$route.params.eventId) {
          this.paths.push(`/cc-events/${this.$route.params.slug}/${this.$route.params.eventId}/info`);
          this.paths.push(`/cc-events/${this.$route.params.slug}/${this.$route.params.eventId}/map`);
          this.paths.push(`/cc-events/${this.$route.params.slug}/${this.$route.params.eventId}/agenda`);
          this.paths.push(`/cc-events/${this.$route.params.slug}/${this.$route.params.eventId}/venue`);
          this.paths.push(`/cc-events/${this.$route.params.slug}/${this.$route.params.eventId}/accommodation`);
          this.paths.push(`/cc-events/${this.$route.params.slug}/${this.$route.params.eventId}/speakers`);
          this.paths.push(`/cc-events/${this.$route.params.slug}/${this.$route.params.eventId}/exhibitors`);
          this.paths.push(`/cc-events/${this.$route.params.slug}/${this.$route.params.eventId}/booked-tables`);
          this.paths.push(`/cc-events/${this.$route.params.slug}/${this.$route.params.eventId}/meeting-rooms`);
          this.paths.push(`/cc-events/${this.$route.params.slug}/${this.$route.params.eventId}/media`);
          this.paths.push(`/cc-events/${this.$route.params.slug}/${this.$route.params.eventId}/participant-companies`);
        } else if (this.$route.params.awardId) {
          this.paths.push(`/cc-awards/${this.$route.params.slug}/${this.$route.params.awardId}/info`);
          this.paths.push(`/cc-awards/${this.$route.params.slug}/${this.$route.params.awardId}/shortlisted`);
          this.paths.push(`/cc-awards/${this.$route.params.slug}/${this.$route.params.awardId}/winners`);
          this.paths.push(`/cc-awards/${this.$route.params.slug}/${this.$route.params.awardId}/map`);
          this.paths.push(`/cc-awards/${this.$route.params.slug}/${this.$route.params.awardId}/agenda`);
          this.paths.push(`/cc-awards/${this.$route.params.slug}/${this.$route.params.awardId}/jury`);
          this.paths.push(`/cc-awards/${this.$route.params.slug}/${this.$route.params.awardId}/categories`);
          this.paths.push(`/cc-awards/${this.$route.params.slug}/${this.$route.params.awardId}/highlights`);
          this.paths.push(`/cc-awards/${this.$route.params.slug}/${this.$route.params.awardId}/exhibitors`);
          this.paths.push(`/cc-awards/${this.$route.params.slug}/${this.$route.params.awardId}/booked-tables`);
          this.paths.push(`/cc-awards/${this.$route.params.slug}/${this.$route.params.awardId}/terms-and-conditions`);
          this.paths.push(`/cc-awards/${this.$route.params.slug}/${this.$route.params.awardId}/media`);
        }

        this.isHome = !this.paths.includes(path);
      },
    },
  },
};
</script>

<style scoped>
@import url(https://fonts.googleapis.com/css?family=Montserrat);
.auth-container {
  margin-top: 7rem;
  margin-bottom: 7rem;

}

.auth-container-home {
  transform: translate(0%, 20%);

}
.footer-home {
  position: relative;
}
#background-video {
    position: absolute;
    width: 100%;
}
.video-container {
    width: 100%;
    position: relative;
    height: 80vh;
}
@media (min-width: 1200px){
.container{
  max-width: 100%;
}
}
@media (min-aspect-ratio: 16/9) {
    #background-video {
        width:100%;
        height: auto;
    }
}
@media (max-aspect-ratio: 4/3) {
    #background-video {
        width:auto;
        height: 100%;
    }
}
@media (max-aspect-ratio: 9/16) {
    #background-video {
        width:auto;
        height: 100%;
        right: -90%;
    }
}
</style>
